import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'enableBrandSelection',
  initialState: false,
  reducers: {
    setEnableBrandSelection(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setEnableBrandSelection } = slice.actions;

export default slice.reducer;
